import { getBrandingColorPalette } from '../../../base/styles';

export const styelOverlay = interfaceConfig => {
    return {
        pageReload: {
            width: '80%',
            maxWidth: '800px',
            borderRadius: '10px',
            margin: 'auto',
            backgroundColor: getBrandingColorPalette(interfaceConfig)?.primary,
            color: '#ffffff',
            padding: '20px',
            textAlign: 'center'
        },
        overlayContainer: {
            maxWidth: '1120px!important',
            marginTop: '5%'
        },
        overlayH4: {
            marginTop: '10px',
            color: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig)?.accent1 : ''
        },
        footerStyle: {
            width: '100%'
        }
    };
};
